import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  Box,
  Typography,
    Checkbox,
    FormGroup,
    FormControlLabel,
    FormLabel,
    MenuItem,
} from '@mui/material';

const NewsletterModal = ({ open, onClose, formData, onChange, onSubmit, error, success }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 600 }}>Early Access</DialogTitle>

      <DialogContent>
        <Typography variant="body2" color="textSecondary" mb={2}>
          Stay up to date with product updates, early access, and news. We just need a few details:
        </Typography>

        <Stack spacing={2}>
          <TextField
            label="First Name"
            name="firstName"
            value={formData.firstName}
            onChange={onChange}
            required
            fullWidth
          />
          <TextField
            label="Last Name"
            name="lastName"
            value={formData.lastName}
            onChange={onChange}
            required
            fullWidth
          />
          <TextField
            label="Phone Number"
            name="phone"
            value={formData.phone}
            onChange={onChange}
            type="phone"
            required
            fullWidth
          />
          <TextField
            label="Email"
            name="email"
            value={formData.email}
            onChange={onChange}
            type="email"
            required
            fullWidth
          />
          <TextField
            label="Role"
            name="role"
            value={formData.role}
            onChange={onChange}
            fullWidth
          />
          <TextField
            label="Firm"
            name="company"
            value={formData.company}
            onChange={onChange}
            fullWidth
          />
          {/* <TextField
                select
                label="Years you have been licensed"
                name="year"
                value={formData.year}
                onChange={onChange}
                required
                fullWidth
                >
                    <MenuItem key={"0"} value={"0-1"}>
                        {"0-1"}
                    </MenuItem>
                    <MenuItem key={"1"} value={"1-3"}>
                        {"1-3"}
                    </MenuItem>
                    <MenuItem key={"3"} value={"3-5"}>
                        {"3-5"}
                    </MenuItem>
                    <MenuItem key={"5"} value={"5+"}>
                        {"5+"}
                    </MenuItem>
                </TextField>

                <FormGroup>
                <FormLabel>What features are you interested in?</FormLabel>
                {["Finding New Leads", "Lead Enrichment", "Reaching Out to Leads", "Advisor Development", "Other"].map((feature) => (
                    <FormControlLabel
                    key={feature}
                    control={
                        <Checkbox
                        name={feature.toLowerCase().replace(/\s+/g, '')}
                        checked={formData[feature.toLowerCase().replace(/\s+/g, '')] || false}
                        onChange={onChange}
                        />
                    }
                    label={feature}
                    />
                ))}
                </FormGroup> */}
                <TextField
            label="Whats your #1 prospecting challenge right now? (Optional)"
            name="comment"
            value={formData.message}
            onChange={onChange}
            multiline
            rows={3}
            fullWidth
          />

          {error && (
            <Box sx={{ color: 'error.main', fontSize: 14, mt: 1 }}>{error}</Box>
          )}
          {success && (
            <Box sx={{ color: 'success.main', fontSize: 14, mt: 1 }}>{success}</Box>
          )}
        </Stack>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'space-between', px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="text">
          Cancel
        </Button>
        <Button variant="contained" onClick={onSubmit} sx={{ textTransform: 'none' }}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewsletterModal;
